<div class="row chart-group indexes" *ngIf="orientation === 'vertical'">
  <div
    class="col-md-6 col-sm-6 col-xs-6"
    [class.margin-top]="showGraph === true"
  >
    <div class="chart-title">ÍNDICES</div>
    <div class="row start-xs title">
      <div class="col-xs-3 start-xs no-padding">
        <span class="title-sec">Índice</span>
      </div>
      <div class="col-xs-3 end-xs no-padding">
        <span class="title-sec">Último</span>
      </div>
      <div class="col-xs-2 end-xs no-padding">
        <span class="title-sec">Cambio</span>
      </div>
      <div class="col-xs-2 end-xs no-padding">
        <span class="title-sec">%</span>
      </div>
      <div class="col-xs-2 end-xs no-padding">
        <span class="title-sec">Volumen</span>
      </div>
    </div>
    <div
      class="row indexes-row"
      *ngFor="let i of indexes"
      [class.selected]="currentIndex === i.name"
      (click)="changeCurrentIndex(i)"
    >
      <div class="col-xs-3 start-xs no-padding ellipsis">
        <span>
          <div
            class="icon"
            [class.icon-arrow-cero]="i.percentageChange === 0"
            [class.icon-arrow-sube]="i.percentageChange > 0"
            [class.icon-arrow-baja]="i.percentageChange < 0"
            [class.neutro]="i.percentageChange === 0"
            [class.positive]="i.percentageChange > 0"
            [class.negative]="i.percentageChange < 0"
          ></div>
        </span>
        <span class="name clickable">
          {{ i.name }}
        </span>
      </div>
      <div class="col-xs-3 end-xs no-padding">
        <span class="number">
          {{ i.lastValue | hbCustomFormat : '0,0.00' }}
        </span>
      </div>
      <div class="col-xs-2 end-xs no-padding">
        <span class="number">
          {{ i.unitChange | hbCustomFormat : '0,0.00' }}
        </span>
      </div>
      <div class="col-xs-2 end-xs no-padding">
        <span class="number">
          {{ i.percentageChange / 100 | hbCustomFormat : '0,0.00%' }}
        </span>
      </div>
      <div class="col-xs-2 end-xs no-padding">
        <span class="number">
          {{ i.volume | hbCustomFormat : '0,0.00a' | uppercase }}
        </span>
      </div>
    </div>
  </div>

  <div
    class="graph-container col-md-6 col-sm-6 col-xs-6"
    *ngIf="showGraph === true && withGraph === true"
  >
    <div class="close">
      <div (click)="toggleGraph(false)" class="icon icon-cancel"></div>
    </div>
    <div class="control-container">
      <div
        class="icon-control left icon-left-arrow"
        (click)="moveGraphIndex(0)"
      ></div>
      <div class="title">
        <span>
          <div
            class="icon"
            [class.icon-arrow-cero]="currentSelected.percentageChange === 0"
            [class.icon-arrow-sube]="currentSelected.percentageChange > 0"
            [class.icon-arrow-baja]="currentSelected.percentageChange < 0"
            [class.neutro]="currentSelected.percentageChange === 0"
            [class.positive]="currentSelected.percentageChange > 0"
            [class.negative]="currentSelected.percentageChangee < 0"
          ></div>
        </span>
        <span>{{ currentSelected.name }}</span>
        <div class="price">
          {{ currentSelected.lastValue | hbCustomFormat : '0,0.00' }}
        </div>
      </div>
      <div
        class="icon-control right icon-right-arrow"
        (click)="moveGraphIndex(1)"
      ></div>
    </div>
    <div class="col-xs-12 no-padding graph">
      <hb-line-chart
        *ngIf="indexData[0]?.series?.length"
        [data]="indexData"
        [view]="[546, 230]"
      ></hb-line-chart>
    </div>
  </div>
</div>

<div class="band-indexes" *ngIf="orientation === 'horizontal'">
  <div
    class="row indexes-row spacing"
    *ngFor="let i of indexes"
    [class.fifth-spacing]="i.name === 'BOVESPA'"
  >
    <span class="name" [class.fifth-index]="i.name === 'BOVESPA'">
      {{ i.name }}
    </span>
    <span class="number" [class.fifth-index]="i.name === 'BOVESPA'">
      {{ i.lastValue | hbCustomFormat : '0,0.00' }}
    </span>
    <span
      class="number"
      [class.neutro-horizontal]="i.percentageChange === 0"
      [class.positive]="i.percentageChange > 0"
      [class.negative]="i.percentageChange < 0"
      [class.fifth-index]="i.name === 'BOVESPA'"
    >
      {{ i.unitChange | hbCustomFormat : '0,0.00' }}
    </span>
    <span
      class="number"
      [class.neutro-horizontal]="i.percentageChange === 0"
      [class.positive]="i.percentageChange > 0"
      [class.negative]="i.percentageChange < 0"
      [class.fifth-index]="i.name === 'BOVESPA'"
    >
      ({{ i.percentageChange / 100 | hbCustomFormat : '0,0.00%' }})
    </span>
  </div>
  <div class="row indexes-row spacing end-xs" *ngIf="!isUsaContract">
    <span class="first">|</span>
    <hb-foreignexchange
      [foreignexchange]="'top'"
      [orientation]="'horizontal'"
    ></hb-foreignexchange>
  </div>
</div>
